var _path, _path2, _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon3DotsCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 42,
    viewBox: "0 0 41 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.5139 20.8818C39.5139 31.3766 31.0189 39.8818 20.5428 39.8818C10.0668 39.8818 1.57178 31.3766 1.57178 20.8818C1.57178 10.3871 10.0668 1.88184 20.5428 1.88184C31.0189 1.88184 39.5139 10.3871 39.5139 20.8818Z",
    fill: "#00B3AE",
    stroke: "#00B3AE",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28198 20.8819C9.28198 19.3806 10.499 18.1597 12.0003 18.1597C13.5015 18.1597 14.7186 19.3806 14.7186 20.8819C14.7186 22.3832 13.5015 23.6041 12.0003 23.6041C10.499 23.6041 9.28198 22.3832 9.28198 20.8819Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.8242,
    y: 18.1597,
    width: 5.43657,
    height: 5.44444,
    rx: 2.71828,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26.3672,
    y: 18.1597,
    width: 5.43657,
    height: 5.44444,
    rx: 2.71828,
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3DotsCircle);
export default __webpack_public_path__ + "static/media/icon_3_dots_circle.092a2ef34ab2dd3b3b49ce7a451f79d8.svg";
export { ForwardRef as ReactComponent };